import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Dental Check-ups',
        'description': 'Comprehensive dental examinations and preventive oral care for patients of all ages.',
    },
    {
        'icon': iconTwo,
        'title': 'Root Canal Treatment',
        'description': 'Expert root canal treatments to relieve pain and save your natural tooth.',
    },
    {
        'icon': iconThree,
        'title': 'Teeth Whitening',
        'description': 'Professional teeth whitening and cosmetic dentistry to brighten your smile.',
    },
    {
        'icon': iconFour,
        'title': 'Homoeopathic Care',
        'description': 'Personalized homeopathic treatments integrated with your dental care plan.',
    }
]

export default ServicesData;